import { AnyAction } from 'redux'
import { ADD_DEBUG_API_CALL } from '~/app/store/debugToolbar/actions'

const initialState: State.DebugToolbarState = {
  apis: [],
}

export function reducer(state: State.DebugToolbarState = initialState, action: AnyAction): State.DebugToolbarState {
  switch (action.type) {
    case ADD_DEBUG_API_CALL: {
      return {
        ...state,
        apis: [...state.apis, action.payload],
      }
    }
    default:
      return state
  }
}

export const getDebugToolbarApis = (state: State.GlobalState): Gallery.ApiResponseWithMetadata.ApiResponse[] => state.debugToolbar.apis
